'use client';

import { useEffect, useState } from 'react';

import { instantWallClock } from '@website/utils/timezone';

const MINUTE_MS = 60 * 1000;

/**
 * The day and minute it is in `timeZone`, kept current: every minute, and as soon as the
 * page is shown again (a tablet left open in a lobby, a tab coming back to the front).
 */
export function useNowInZone(timeZone: string): { date: string; minutes: number } {
  const [now, setNow] = useState(() => instantWallClock(Date.now(), timeZone));

  useEffect(() => {
    const refresh = () => {
      const next = instantWallClock(Date.now(), timeZone);
      setNow((previous) => (previous.date === next.date && previous.minutes === next.minutes ? previous : next));
    };
    refresh();
    const timer = window.setInterval(refresh, MINUTE_MS);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [timeZone]);

  return now;
}
